// Auto-generated by scripts/scrape_widget_parts.py — do not edit manually
export const widgetPartsMeta = {
  "1": {
    "url": "https://www.jjssxzz.cn/thesisDetails#10.11659/jjssx.06E025035&lang=en",
    "source": "dom",
    "htmlLen": 22905,
    "cssLen": 6822
  },
  "2": {
    "url": "https://www.cancerbiomed.org/content/22/3/212",
    "source": "api",
    "htmlLen": 19714,
    "cssLen": 4564
  },
  "3": {
    "url": "http://www.geosciencefrontiers.com/en/article/doi/10.1016/j.gsf.2025.102158",
    "source": "dom",
    "htmlLen": 24732,
    "cssLen": 6163
  },
  "4": {
    "url": "https://accscience.com/journal/IJB/10/5/10.36922/ijb.4054",
    "source": "api",
    "htmlLen": 18353,
    "cssLen": 6201
  }
};

export const widgetPartsHtml = {
  1: `<div class="contrimetrics_weight_section"><div class="contrimetrics_weight_section"><div class="contrimetrics_weight_section_left"><div class="contrimetrics_weight_inside__section_top_left" style="background-color: transparent !important; color: rgb(0, 0, 0) !important; font-size: 0.117188rem !important;">Recommendations</div><div class="contrimetrics_weight_inside_section_bottom" style="padding: 0px;"><div class="contrimetrics_weight_item" data-widgetitem="7gBDRkoC9t9QMWCaub2zc3Sn+Dgc/hqWkL8xxdGXKoNhW6niScESazXCXPqEeHCtUV/ZBNxvIsenNN3X3OAdURyU40PuENAEabIEkFsAUkAOXi/yMdJPNOuJkeFVvG0CBtgTdXGBa5vKLJxTZq0BnghWe7OyzRIg" data-doi="10.11659/jjssx.10e024081" data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fwww.jjssxzz.cn%2FthesisDetails%3FcolumnId%3D117536864%26lang%3Den"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Influencing factors of liver regeneration after laparoscopic anatomic liver resection and its relationship with prognosis">Influencing factors of liver regeneration after laparoscopic anatomic liver resection and its relationship with prognosis</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">BI Jing-peng et al., Journal of Regional Anatomy and Operative Surgery, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="uK18dC+EdK7I5AAL92av0ATmOEg9lRrekL8xxdGXKoNhW6niScESazXCXPqEeHCtUV/ZBNxvIsenNN3X3OAdURyU40PuENAEabIEkFsAUkAOXi/yMdJPNOuJkeFVvG0CBtgTdXGBa5vKLJxTZq0BnghWe7OyzRIg" data-doi="10.11659/jjssx.11e024006" data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fwww.jjssxzz.cn%2FthesisDetails%3FcolumnId%3D126871025%26lang%3Den"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Effect of ipkp in the treatment of thoracolumbar ovcf and analysis of risk factors for postoperative bone cement leakage">Effect of ipkp in the treatment of thoracolumbar ovcf and analysis of risk factors for postoperative bone cement leakage</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">YANG Tao et al., Journal of Regional Anatomy and Operative Surgery, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="uK18dC+EdK63Z8QJoTE/orpYWvvn0iFFkL8xxdGXKoNhW6niScESazXCXPqEeHCtUV/ZBNxvIsenNN3X3OAdURyU40PuENAEabIEkFsAUkAOXi/yMdJPNOuJkeFVvG0CBtgTdXGBa5vKLJxTZq0BnghWe7OyzRIg" data-doi="10.11659/jjssx.06e024013" data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fwww.jjssxzz.cn%2FthesisDetails%3FcolumnId%3D126871337%26lang%3Den"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Risk factors analysis of residual displacement after kirschner wire internal fixation for unstable humeral supracondylar fracture in children">Risk factors analysis of residual displacement after kirschner wire internal fixation for unstable humeral supracondylar fracture in children</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">MA Xu-bin et al., Journal of Regional Anatomy and Operative Surgery, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="7gBDRkoC9t/mJJuvtDPrELK/ZSEq+nCvkL8xxdGXKoNhW6niScESazXCXPqEeHCtUV/ZBNxvIsenNN3X3OAdURyU40PuENAEabIEkFsAUkAOXi/yMdJPNOuJkeFVvG0CBtgTdXGBa5vKLJxTZq0BnghWe7OyzRIg" data-doi="10.11659/jjssx.10e024034" data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fwww.jjssxzz.cn%2FthesisDetails%3FcolumnId%3D117536767%26lang%3Den"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Risk factors of the peri-operative hidden blood loss in artificial femoral head replacement">Risk factors of the peri-operative hidden blood loss in artificial femoral head replacement</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">LIU Yong-quan et al., Journal of Regional Anatomy and Operative Surgery, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="DWpfHzq6ffTX9+J6IHFnjreBb35WYBCqkL8xxdGXKoNa2PHfIAB099BwsFBDFy+bUV/ZBNxvIsdAJBbJs6CwE29MFB+z+P+553US9P/pPOtnGs70oX4i9wwS/XFLEKZn" data-doi="10.12114/j.issn.1007-9572.2023.0139" data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fwww.chinagp.net%2FEN%2F10.12114%2Fj.issn.1007-9572.2023.0139"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAORQTFRF/4UN/65h/59B/4cO/3oA/4oM/5ku/unU/5Ml/urV/+XJ/uLD/4cQ/4US/4EU/tuy/4IX/5cu/4UX/5Qu/6BA/8mQ/fz5/t+9/fn0/6hQ/7Nj/44Z/6tT/8aK/9Ki/5gw/4gX/7Bf/+/W/4EL/3cA/5Uo/5Mo/uC//fz6/4gM/uTK/5Qj/vbr/+zX/4cU/4sZ//Xj/fr2/6RE/4UZ/vjy/8SG/8+a/fTr/4QN/fz7/+PD/6dZ/8SE/4UE/+za/tOm/6A7/fv4/fPn/5k5/7Zn/fjz/4YO/fPp/4IC/4QL/Pz8/f39kJkK8AAAAIFJREFUeNpi8AYCMXVrDzdNNjkQmwFEWOkZO0jJqCnCBZyVlSy9vTlNvL29vMACHNL8QCYEgAXMVATsnZAFDEV5+ER0JRAC3o52TEKepq4IAW9vc3EFFllkAS8vLW1muIAOu7e3u4GFIFxAXlXSxYhXnwsuYCPMymDLyK0B0gkQYAA1DSzyAfGHxwAAAABJRU5ErkJggg==" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Development and validation of a risk prediction model for contrast-induced acute kidney injury after percutaneous coronary intervention in patients with acute myocardial infarction">Development and validation of a risk prediction model for contrast-induced acute kidney injury after percutaneous coronary intervention in patients with acute myocardial infarction</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">WANG  Zhen et al., Chinese General Practice, 2023</div></div></div></div></div><div class="contrimetrics_weight_section_right"><div class="contrimetrics_weight_inside__section_top_right" style="white-space: pre; color: rgb(0, 0, 0) !important; background-color: transparent !important; font-size: 0.117188rem !important; display: none;"> </div><div class="contrimetrics_weight_inside_section_bottom"><div class="contrimetrics_weight_item" data-widgetitem="bAyI7y2u4k0tQPc34SvlfbUcyKykY+DNkL8xxdGXKoMsj8fZQB7/c8je+QZnGympUV/ZBNxvIsd6ZgkAtLgNPByU40PuENAE0PmZFoKZBuuLgJu0pmaBI2HWqQqEe+ecW5KIJ/zIDjX+CeQP5E/Mvg==" data-doi="10.3969/j.issn.2095-9400.2025.04.004" data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fxb.wmu.edu.cn%2FthesisDetails%3FcolumnId%3D89790967%26lang%3Den"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Influencing factors and risk prediction model construction of lower extremity deep vein thrombosis in the perioperative period of frailty elderly patients with hip fracture">Influencing factors and risk prediction model construction of lower extremity deep vein thrombosis in the perioperative period of frailty elderly patients with hip fracture</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">ZHENG Lidan et al., Journal of Wenzhou Medical University, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="kebfaN3/osP8rWO2z+EPLJInP/gv+SEJkL8xxdGXKoMY9BYgdtqQadKBjT8Xfe7OUV/ZBNxvIsdURlb+whkYH/qvgY/+tqggLsB4ivuKGkx5igljQb1D8hl2IjeoCXiJ1Fj3ik88b4UvAxinz3R4OB86nBRtUUYc" data-doi="10.31579/2641-0419/515" data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fauctoresonline.org%2Farticle%2Frisk-factors-for-adverse-one-year-prognosis-in-patients-with-chronic-cerebral-ischemia-after-myocardial-infarction-complicated-by-heart-failure-with-reduced-ejection-fraction"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Risk factors for adverse one-year prognosis in patients with chronic cerebral ischemia after myocardial infarction complicated by heart failure with reduced ejection fraction">Risk factors for adverse one-year prognosis in patients with chronic cerebral ischemia after myocardial infarction complicated by heart failure with reduced ejection fraction</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">N.B. Lebedeva et al., Clinical Cardiology and Cardiovascular Interventions, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="ilB052iA4d+/8yonptJqz72f+88KEGBKkL8xxdGXKoNUKi7BNZ9LlwgwXNrJF/91UV/ZBNxvIseHSAHmKBZmsxyU40PuENAET+j863QZQiUy+LScDIeJhY3n+Ejjwah0i+5k+5Eq393BFiSAB9kL1gqazWTGeXnn" data-doi="10.11817/j.issn.1672-7347.2023.230018" data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fxbyxb.csu.edu.cn%2FthesisDetails%3FFpath%3Dhome%26amp%3BcolumnId%3D35758986%26amp%3Bindex%3D0%26amp%3Blang%3Den"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Prediction model of atrial fibrillation recurrence after cox-maze iv procedure in patients with chronic valvular disease and atrial fibrillation based on machine learning algorithm">Prediction model of atrial fibrillation recurrence after cox-maze iv procedure in patients with chronic valvular disease and atrial fibrillation based on machine learning algorithm</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">JIANG Zenan et al., Journal of Central South University(medical Science), 2023</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="IFOoFNBPiPmVkUkZylmO7wMqKnEbqlRVwjMmqjL1Yw+myzYkv0TN5jf2+tRLDNQkQE2ArY5a5IgMEv1xSxCmZw==" data-doi="10.56434/j.arch.esp.urol.20237608.68" data-website=""><div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Prevalence, risk factors and clinical outcomes of acute kidney injury after paediatric liver transplantation">Prevalence, risk factors and clinical outcomes of acute kidney injury after paediatric liver transplantation</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">Archivos Espanoles De Urologia, 2023</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="IFOoFNBPiPk6VVPPBzA1ijVoZipqML45wjMmqjL1Yw+myzYkv0TN5jf2+tRLDNQkQE2ArY5a5IgMEv1xSxCmZw==" data-doi="10.56434/j.arch.esp.urol.20237606.51" data-website=""><div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important; width: 0.109375rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 0.109375rem !important; cursor: pointer;" title="Construction and verification of predictive model for influencing factors of quality of life in patients with type 2 diabetic nephropathy: a hospital-based retrospective study">Construction and verification of predictive model for influencing factors of quality of life in patients with type 2 diabetic nephropathy: a hospital-based retrospective study</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;">Archivos Espanoles De Urologia, 2023</div></div></div></div></div></div></div><div class="contrimetrics_weight_bottom"><div class="inside_contrimetrics_weight_bottom" style="color: rgb(162, 177, 182) !important; font-size: 0.109375rem !important;"> <div class="contrimetrics_weight_bottom_inner">Powered by <a href="https://contrimetrics.com/login?journalId=1935235368180159197" target="_blank"><img hspace="5" src="data:image/png;base64,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" alt=""></a></div><div class="contrimetrics_weight_favorite" style="display: none !important;">
<span class="contrimetrics_weight_alert"></span><div><input type="text" placeholder="EMAIL ADDRESS"> <a href="javascript:void(0)">Favorite</a></div>
</div></div></div>`,
  2: `<div class="contrimetrics_weight_section"><div class="contrimetrics_weight_section"><div class="contrimetrics_weight_section_left"><div class="contrimetrics_weight_inside__section_top_left" >Cited by <div class="contrimetrics_mark" data-title="In this plugin, the abbreviations WSC prefixed before each paper signify the paper being indexed in different databases: W for WoS, S for Scopus, and C for Contrimetric.">?</div></div><div class="contrimetrics_weight_inside_section_bottom"><div class="contrimetrics_weight_item" data-widgetitem="DhjagEvTHL2TH746Vj5Xcp4tzPDpNX3B9AqOIWrdalxkmd3cLqb/t0j5Atf1Bk4o/gnkD+RPzL4="  data-doi="10.3748/wjg.119127"  data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Early screening and risk factors for gastric cancer</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Jiaojiao Jiang et al., World Journal of Gastroenterology, 2026</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="DhjagEvTHL3yIOuvjiAnYwHKfgb9XlgAwovyIEO3oSHFeQZcnmo/wg=="  data-doi="10.1016/j.ctrv.2026.103176"  data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Precision targeting of cldn18.2: a new therapeutic paradigm for gastric cancer</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Wei Zhou et al., Cancer Treatment Reviews, 2026</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="DhjagEvTHL1xuH9oDqvuLe0EDHGav4sBBBZ4EM6m7jUOqHXS7OKoyg=="  data-doi="10.3389/fimmu.2026.1745356"  data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Efficacy and safety of neoadjuvant chemoradiotherapy combined with immunotherapy for locally advanced esophagogastric junction or gastric cancer: a systematic review and meta analysis</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Xiaoxuan Ma et al., Frontiers in Immunology, 2026</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="DhjagEvTHL2TH746Vj5XctrumiS6y9Qrni3M8Ok1fcE3Mn9TEZKgeDDtSeW3S5KHbZw/3gLDjjU="  data-doi="10.11569/wcjd.v34.i5.345"  data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAORQTFRF/4UN/65h/59B/4cO/3oA/4oM/5ku/unU/5Ml/urV/+XJ/uLD/4cQ/4US/4EU/tuy/4IX/5cu/4UX/5Qu/6BA/8mQ/fz5/t+9/fn0/6hQ/7Nj/44Z/6tT/8aK/9Ki/5gw/4gX/7Bf/+/W/4EL/3cA/5Uo/5Mo/uC//fz6/4gM/uTK/5Qj/vbr/+zX/4cU/4sZ//Xj/fr2/6RE/4UZ/vjy/8SG/8+a/fTr/4QN/fz7/+PD/6dZ/8SE/4UE/+za/tOm/6A7/fv4/fPn/5k5/7Zn/fjz/4YO/fPp/4IC/4QL/Pz8/f39kJkK8AAAAIFJREFUeNpi8AYCMXVrDzdNNjkQmwFEWOkZO0jJqCnCBZyVlSy9vTlNvL29vMACHNL8QCYEgAXMVATsnZAFDEV5+ER0JRAC3o52TEKepq4IAW9vc3EFFllkAS8vLW1muIAOu7e3u4GFIFxAXlXSxYhXnwsuYCPMymDLyK0B0gkQYAA1DSzyAfGHxwAAAABJRU5ErkJggg==" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Artificial intelligence for gastric cancer: advances and current status in diagnosis and therapy</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Zhao-Chun Chi, World Chinese Journal of Digestology, 2026</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="" data-doi="" data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;"><a href="https://citation.contrimetric.com/citations?doi=10.20892/j.issn.2095-3941.2024.0386" target="_blank" style="color: #333 !important; text-decoration: none !important; font-weight: bold !important; font-size: inherit !important;">Click To View More Citations...</a></div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important; color: #526065 !important;font-weight: bold !important; font-style: italic !important;">View additional citations for this paper</div></div></div></div></div><div class="contrimetrics_weight_section_right"><div class="contrimetrics_weight_inside__section_top_right" >Recommendations</div><div class="contrimetrics_weight_inside_section_bottom"><div class="contrimetrics_weight_item" data-widgetitem="XwcHhag23nDSqJfCqLk9p4/uQCnUrGpBkL8xxdGXKoMsXatNQBD1puhaJ13NbVy1UV/ZBNxvIsdIs70XMsSjLl0CWgcfEars4KwF6CTNfhFCectBfSPxgG6rdekQdJji"  data-doi="10.20892/j.issn.2095-3941.2023.0280"  data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fwww.cancerbiomed.org%2Fcontent%2F21%2F2%2F105"> <div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Circulating cell-free mtdna as a new biomarker for cancer detection and management</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Fan Peng et al., Cancer Biology & Medicine, 2024</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="HcrvEeOMQNpVblC4xHMfk0woSJ0uwz2ykL8xxdGXKoMsXatNQBD1puhaJ13NbVy1UV/ZBNxvIsdIs70XMsSjLl0CWgcfEars4KwF6CTNfhFCectBfSPxgG6rdekQdJji"  data-doi="10.20892/j.issn.2095-3941.2024.0044"  data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fwww.cancerbiomed.org%2Fcontent%2F21%2F6%2F484%2Ftab-article-info"> <div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Advances in met tyrosine kinase inhibitors in gastric cancer</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Yifan Zhang et al., Cancer Biology & Medicine, 2024</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="UUE3vV3EmZH2jIQHS6iPnawOI4VkTASykL8xxdGXKoNUKi7BNZ9Ll+haJ13NbVy1UV/ZBNxvIsd5B2U5Aa1FCukyuEyyzJ/Zh3FNLdeX5sYgBVav2cZFoMJsAdOgmcDLJmrtM/jtcLU="  data-doi="10.26689/par.v8i5.7177"  data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fojs.bbwpublisher.com%2Findex.php%2FPAR%2Farticle%2Fview%2F7177"> <div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Advancements and challenges in biomarkers for colorectal cancer detection: a comprehensive review</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Yasir Hameed et al., Proceedings of Anticancer Research, 2024</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="mOukS8u9Tn+ZOIpZ6GvlXgoSGX1s6s3WkL8xxdGXKoOByUg/ux2XI9KBjT8Xfe7OUV/ZBNxvIsdhfJeffA2/jhyU40PuENAErYRLjPF/K0dDhvczFG5hPi1b+3TRxM73Urn/wo1Al6U48oaOI0jS1w=="  data-doi="10.20517/2394-4722.2024.107"  data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fwww.oaepublish.com%2Farticles%2F2394-4722.2024.107"> <div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Predictive biomarkers for immunotherapy in gastric cancer</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Sijia Li et al., Journal of Cancer Metastasis and Treatment, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="BLmLk9cOSzGS7ni8xFIAPsuCzra4ws8gluX4EMLkIBbhXmgDLlN2oIH24Z4jmB8dgo1eU2EbxOR9WC170ssqWKZitfah8MjH"  data-doi="10.62347/mjoa5699"  data-website=""><div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Predictive and prognostic value of combined detection of slim-3, pg and pd-l1 in immune checkpoint inhibitor therapy for advanced gastric cancer</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">American Journal of Translational Research, 2024</div></div></div></div></div></div></div><div class="contrimetrics_weight_bottom"><div class="inside_contrimetrics_weight_bottom"> <div class="contrimetrics_weight_bottom_inner">Powered by <a href="https://contrimetrics.com/login?journalId=1935235368180159810" target="_blank"><img hspace="5" src="data:image/png;base64,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" alt=""></a></div><div class="contrimetrics_weight_favorite">
<span class="contrimetrics_weight_alert"></span><div><input type="text" placeholder="EMAIL ADDRESS"> <button>
Favorite</button></div>
</div></div></div>`,
  3: `<div class="contrimetrics_weight_section"><div class="contrimetrics_weight_section"><div class="contrimetrics_weight_section_left"><div class="contrimetrics_weight_inside__section_top_left" style="background-color: transparent !important; color: rgb(0, 0, 0) !important; font-size: 1.6rem !important;">Recommendations</div><div class="contrimetrics_weight_inside_section_bottom" style="padding: 0.75rem 0px;"><div class="contrimetrics_weight_item" data-widgetitem="UAouNguQGqfYZM0aAOyBeEI2819aYQGOkL8xxdGXKoMM05HQWAuNXxExwMcjFsxhUV/ZBNxvIsdtGenSuDu91FboiU2T5CMGHv3mlVynD1Eg5FhwILNTdw==" data-doi="10.1016/j.gsf.2023.101768" data-website="https://contrimetric.com/resolve/?target=http%3A%2F%2Fwww.geosciencefrontiers.com%2Farticle%2Fdoi%2F10.1016%2Fj.gsf.2023.101768"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="Contrasting sources and enrichment mechanisms in lithium-rich salt lakes: a li-h-o isotopic and geochemical study from northern tibetan plateau">Contrasting sources and enrichment mechanisms in lithium-rich salt lakes: a li-h-o isotopic and geochemical study from northern tibetan plateau</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">Fei Xue et al., Geoscience Frontiers, 2024</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="5T257uvOt5vmH2h5yQNY5CN977HJI6hOkL8xxdGXKoMM05HQWAuNXxExwMcjFsxhUV/ZBNxvIsdtGenSuDu91FboiU2T5CMGHv3mlVynD1FTmqIO2YMoIw==" data-doi="10.1016/j.gsf.2024.101940" data-website="https://contrimetric.com/resolve/?target=http%3A%2F%2Fwww.geosciencefrontiers.com%2Farticle%2Fdoi%2F10.1016%2Fj.gsf.2024.101940"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="Stability and physical properties of brucite at high pressures and temperatures: implication for earth’s deep water cycle">Stability and physical properties of brucite at high pressures and temperatures: implication for earth’s deep water cycle</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">Ningyu Sun et al., Geoscience Frontiers, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="Mntt8dyI9QRBrRPxUQUzaEMMUggOBjThkL8xxdGXKoMM05HQWAuNXxExwMcjFsxhUV/ZBNxvIsdtGenSuDu91FboiU2T5CMGHv3mlVynD1FTmqIO2YMoIw==" data-doi="10.1016/j.gsf.2025.102001" data-website="https://contrimetric.com/resolve/?target=http%3A%2F%2Fwww.geosciencefrontiers.com%2Farticle%2Fdoi%2F10.1016%2Fj.gsf.2025.102001"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="Lithium isotopes in the geothermal waters of the india–asia continental convergent margin: source and evolution">Lithium isotopes in the geothermal waters of the india–asia continental convergent margin: source and evolution</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">Yinlei Hao et al., Geoscience Frontiers, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="5T257uvOt5ustvM7nQ9U9HRWiLBYCVyzkL8xxdGXKoMM05HQWAuNXxExwMcjFsxhUV/ZBNxvIsdtGenSuDu91FboiU2T5CMGHv3mlVynD1Eg5FhwILNTdw==" data-doi="10.1016/j.gsf.2024.101900" data-website="https://contrimetric.com/resolve/?target=http%3A%2F%2Fwww.geosciencefrontiers.com%2Farticle%2Fdoi%2F10.1016%2Fj.gsf.2024.101900"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="Deep recycling of volatile elements in the mantle: evidence from the heterogeneous b isotope in intra-plate basalts">Deep recycling of volatile elements in the mantle: evidence from the heterogeneous b isotope in intra-plate basalts</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">Yan-Qing Li et al., Geoscience Frontiers, 2024</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="AZUetHBaJ7ysrP4bti85mWiiUDeNDMHdewfhsdf5BvTMdGGVqc8JyHHaVbT6AZG3f9btI3a/RYCSPjbhCKGG5w==" data-doi="10.26480/esp.01.2023.21.26" data-website=""><div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="Paleontology, stratigraphy and paleogeography of the tethyan maastrichtian-neogene rotaliid benthic foraminiferal members of the genus pararotalia">Paleontology, stratigraphy and paleogeography of the tethyan maastrichtian-neogene rotaliid benthic foraminiferal members of the genus pararotalia</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">Haidar Salim Anan, Earth Sciences Pakistan, 2023</div></div></div></div></div><div class="contrimetrics_weight_section_right"><div class="contrimetrics_weight_inside__section_top_right" style="white-space: pre; color: rgb(0, 0, 0) !important; background-color: transparent !important; font-size: 1.6rem !important;"> </div><div class="contrimetrics_weight_inside_section_bottom"><div class="contrimetrics_weight_item" data-widgetitem="NPsbgSqKGvhIss6NRIY4wsP736funs5gkL8xxdGXKoPcaizzzbz7FhExwMcjFsxhUV/ZBNxvIsddZCq/0osA6NLnL1qCdn/AffKU51CSC/VIr82p/c9erQ==" data-doi="10.7522/j.issn.1000-0534.2024.00015" data-website="https://contrimetric.com/resolve/?target=http%3A%2F%2Fwww.gyqx.ac.cn%2FEN%2F10.7522%2Fj.issn.1000-0534.2024.00015"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAORQTFRF/4UN/65h/59B/4cO/3oA/4oM/5ku/unU/5Ml/urV/+XJ/uLD/4cQ/4US/4EU/tuy/4IX/5cu/4UX/5Qu/6BA/8mQ/fz5/t+9/fn0/6hQ/7Nj/44Z/6tT/8aK/9Ki/5gw/4gX/7Bf/+/W/4EL/3cA/5Uo/5Mo/uC//fz6/4gM/uTK/5Qj/vbr/+zX/4cU/4sZ//Xj/fr2/6RE/4UZ/vjy/8SG/8+a/fTr/4QN/fz7/+PD/6dZ/8SE/4UE/+za/tOm/6A7/fv4/fPn/5k5/7Zn/fjz/4YO/fPp/4IC/4QL/Pz8/f39kJkK8AAAAIFJREFUeNpi8AYCMXVrDzdNNjkQmwFEWOkZO0jJqCnCBZyVlSy9vTlNvL29vMACHNL8QCYEgAXMVATsnZAFDEV5+ER0JRAC3o52TEKepq4IAW9vc3EFFllkAS8vLW1muIAOu7e3u4GFIFxAXlXSxYhXnwsuYCPMymDLyK0B0gkQYAA1DSzyAfGHxwAAAABJRU5ErkJggg==" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="A study on the evolution characteristics of qinghai lake ice in recent 40 years based on an analytical model">A study on the evolution characteristics of qinghai lake ice in recent 40 years based on an analytical model</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">Hong TANG et al., Plateau Meteorology, 2024</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="1+ims3/+PnLqoAUA3aavwSTSj5hAke6BkL8xxdGXKoO7YyNn0ur7L8je+QZnGympUV/ZBNxvIseV98cPxVB0chyU40PuENAE4/t68611txZPhiACUzkxyULlIIsijfvesYx3J1F5aczIHWFeQxhY1Q==" data-doi="10.13870/j.cnki.stbcxb.2026.01.029" data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fwww.stbcxb.com.cn%2FthesisDetails%3FcolumnId%3D151281162%26lang%3Den"> <div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="Spatiotemporal evolution of trade-off and synergy relationship between water conservation and soil retention functions in erhai lake basin">Spatiotemporal evolution of trade-off and synergy relationship between water conservation and soil retention functions in erhai lake basin</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">DENG Yuzhuang et al., Journal of Soil and Water Conservation, 2026</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="ZmJzUHOyGs2XZLvLU90bEll3vx5L7TdbBS1Da9lxhgWU0+7Vp+waL9zXKT0k8Fqj+n94/YFq5Kir89YdXbp91g==" data-doi="10.26480/esmy.01.2021.01.09" data-website=""><div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="The major elemental composition of middle paleocene sediments of southern indus basin pakistan: implication on provenance">The major elemental composition of middle paleocene sediments of southern indus basin pakistan: implication on provenance</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">Asghar A.A.D. Hakro et al., Earth Science Malaysia, 2020</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="/NixmUL0zfARp9FiVPlsMIDiygRQ2tNdU79SQiOvVSFXQE6cDD4Cpou9XhTGuex9TyCrXyDIdWM=" data-doi="10.1016/j.earscirev.2024.104718" data-website=""><div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="Tracing the source areas of detrital zircon and k-feldspar in the yellow river basin">Tracing the source areas of detrital zircon and k-feldspar in the yellow river basin</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">Earth-Science Reviews, 2024</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="gLajuF5C7+rOU26t1A5q5WDuVVHO20Lo09r/jFK7gUExuhMT8CYcS/bbTdp+LKSofj/sMQQeKxnPdocMuyE0ow==" data-doi="10.1038/s43247-025-02669-4" data-website=""><div class="contrimetrics_weight_item_checkbox" style="padding: 3px 2px 1px 0px !important;"><input type="checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important; width: 1.4rem !important;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(0, 0, 0) !important; font-size: 1.5rem !important; cursor: pointer;" title="Flood inundation amplified by large-scale ground subsidence funnel under the ongoing global climate change">Flood inundation amplified by large-scale ground subsidence funnel under the ongoing global climate change</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space: normal !important; overflow-wrap: break-word !important; hyphens: none !important; color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;">Communications Earth &amp; Environment, 2025</div></div></div></div></div></div></div><div class="contrimetrics_weight_bottom"><div class="inside_contrimetrics_weight_bottom" style="color: rgb(162, 177, 182) !important; font-size: 1.5rem !important;"> <div class="contrimetrics_weight_bottom_inner">Powered by <a href="https://contrimetrics.com/login?journalId=1935235368180159261" target="_blank"><img hspace="5" src="data:image/png;base64,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" alt=""></a></div><div class="contrimetrics_weight_favorite" style="display: none !important;">
<span class="contrimetrics_weight_alert"></span><div><input type="text" placeholder="EMAIL ADDRESS"> <a href="javascript:void(0)">Favorite</a></div>
</div></div></div>`,
  4: `<div class="contrimetrics_weight_section"><div class="contrimetrics_weight_section"><div class="contrimetrics_weight_section_left"><div class="contrimetrics_weight_inside__section_top_left" >Cited by <div class="contrimetrics_mark" data-title="In this plugin, the abbreviations WSC prefixed before each paper signify the paper being indexed in different databases: W for WoS, S for Scopus, and C for Contrimetric.">?</div></div><div class="contrimetrics_weight_inside_section_bottom"><div class="contrimetrics_weight_item" data-widgetitem="DhjagEvTHL3q4Fhwlj6Mgq06FGxT/PuSni3M8Ok1fcE+i3NWm6OE8SS4nnHyFVki/YQAESpiHC5krJkZnH9/hcgdYV5DGFjV"  data-doi="10.1016/j.ijbiomac.2026.152973"  data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Characterization and development of a gelatin/elastin methacrylamide-based bioink for creating a 3d bioprinted human skin model.</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">C. S. Silva et al., International Journal of Biological Macromolecules, 2026</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="DhjagEvTHL2J5fYxHbbyQuVVMVfcv2TX/gnkD+RPzL4="  data-doi="10.3390/organoids4040026"  data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Integrating 3d bioprinting with organoid technology-based breast cancer models for drug evaluation</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">A. Shukla et al., Organoids, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="DhjagEvTHL0knGLaTTBH3Djyho4jSNLX"  data-doi="10.7759/cureus.97947"  data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Advances and challenges in 3d bioprinting for organ transplantation: bridging the gap between research and clinical applications</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Anupriya Velu et al., Cureus, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="DhjagEvTHL308etUpii/Rso+hz5OOMSJUlO1mSgFF9YIVnuzss0SIA=="  data-doi="10.1016/j.advop.2025.10.001"  data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Preparation of intervertebral disc organoid and regeneration mechanism based on gradient structure and mechanical function guidance: a review</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">M. A. Haque et al., Advanced Orthopaedics, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="" data-doi="" data-website=""><div class="contrimetrics_weight_item_checkbox"></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;"><a href="https://citation.contrimetric.com/citations?doi=10.36922/ijb.4054" target="_blank" style="color: #333 !important; text-decoration: none !important; font-weight: bold !important; font-size: inherit !important;">Click To View More Citations...</a></div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important; color: #526065 !important;font-weight: bold !important; font-style: italic !important;">View additional citations for this paper</div></div></div></div></div><div class="contrimetrics_weight_section_right"><div class="contrimetrics_weight_inside__section_top_right" >Recommendations</div><div class="contrimetrics_weight_inside_section_bottom"><div class="contrimetrics_weight_item" data-widgetitem="3B/KxkhdnYqQ06+nPkx3VKVYPhk87DPHkL8xxdGXKoPm+kDSxQTWGtWLR2fW7aM0UV/ZBNxvIseXXSp3AcU7RTgY0OtgXkSzqURPP93keHlksCmx1El8q8AFdGaqplH/ylYdwUIQw4o="  data-doi="10.36922/ijb.4092"  data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Faccscience.com%2Fjournal%2FIJB%2F10%2F6%2F10.36922%2Fijb.4092"> <div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">3d bioprinting technologies for the enhancement and application of functional lung organoid models</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Jimin Jang et al., International Journal of Bioprinting, 2024</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="uj8RtWHI1aDF6aElRep8wac33HTJRKTtkL8xxdGXKoPm+kDSxQTWGtWLR2fW7aM0UV/ZBNxvIsc4q0TNpVJreZZZdoy3u8zl18qSSVxoMuQIVnuzss0SIA=="  data-doi="10.36922/or025040004"  data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Faccscience.com%2Fjournal%2FOR%2F1%2F1%2F10.36922%2FOR025040004"> <div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Advancing organoid development with 3d bioprinting</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Wenping Ma et al., Organoid Research, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="VaBs1IQpr8JKRQbrM0mMLhcsZiQDQrtIkL8xxdGXKoMOXcEkKtVCoNBwsFBDFy+bUV/ZBNxvIscBagR9RDhzn0amchjubJKcX3ioU3dEpXzQR5+q9o6gYA=="  data-doi="10.1093/burnst/tkaf006"  data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Facademic.oup.com%2Fburnstrauma%2Farticle%2Fdoi%2F10.1093%2Fburnst%2Ftkaf006%2F7972812"> <div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Extracellular vesicles in burn injury: roles, mechanisms, and applications</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Wang et al., Burns & Trauma, 2025</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="RcOBR/0RJdcsA8CVHtB91OItdPc37xQzkL8xxdGXKoOh7Br46TYW4tWLR2fW7aM0UV/ZBNxvIseE/6kCQJxAjhyU40PuENAEexrAoskSLyzenXladtOT8gAP68PkzQxEyP/TDt8EtEEmau0z+O1wtQ=="  data-doi="10.11665/j.issn.1000-5048.2023113001"  data-website="https://contrimetric.com/resolve/?target=https%3A%2F%2Fjcpu.cpu.edu.cn%2Fen%2Farticle%2Fdoi%2F10.11665%2Fj.issn.1000-5048.2023113001"> <div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAORQTFRF/4UN/65h/59B/4cO/3oA/4oM/5ku/unU/5Ml/urV/+XJ/uLD/4cQ/4US/4EU/tuy/4IX/5cu/4UX/5Qu/6BA/8mQ/fz5/t+9/fn0/6hQ/7Nj/44Z/6tT/8aK/9Ki/5gw/4gX/7Bf/+/W/4EL/3cA/5Uo/5Mo/uC//fz6/4gM/uTK/5Qj/vbr/+zX/4cU/4sZ//Xj/fr2/6RE/4UZ/vjy/8SG/8+a/fTr/4QN/fz7/+PD/6dZ/8SE/4UE/+za/tOm/6A7/fv4/fPn/5k5/7Zn/fjz/4YO/fPp/4IC/4QL/Pz8/f39kJkK8AAAAIFJREFUeNpi8AYCMXVrDzdNNjkQmwFEWOkZO0jJqCnCBZyVlSy9vTlNvL29vMACHNL8QCYEgAXMVATsnZAFDEV5+ER0JRAC3o52TEKepq4IAW9vc3EFFllkAS8vLW1muIAOu7e3u4GFIFxAXlXSxYhXnwsuYCPMymDLyK0B0gkQYAA1DSzyAfGHxwAAAABJRU5ErkJggg==" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Research progress on mesenchymal stem cell products and their exosomes in the treatment of inflammatory bowel disease</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">YANG Jingwen et al., Journal of China Pharmaceutical University, 2024</div></div></div><div class="contrimetrics_weight_item" data-widgetitem="BLmLk9cOSzHqb2DBlISINrWQJlpeMa7EtDFQh22820Ks9kIr+W1hNoR1ks+Y7Y3dNnWUTdkKOZsu9bc12JDeFQUeUfevy92R"  data-doi="10.1016/j.abb.2023.109822"  data-website=""><div class="contrimetrics_weight_item_checkbox"><input type="checkbox"/></div><div class="contrimetrics_weight_item_warp_right"><div class="contrimetrics_weight_item_one"><div class="contrimetrics_weight_item_left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAMAAABcOc2zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFQTFRFYjjB+Pf60cXreVXKeFTJXzXA9PL4nIPX7Oj1YznBa0PEyLronYPXnILXzsLqzcDq1crtcEnGo4vataHgtqPh7Oj2ZDrB29Lv2dDu4dnx7uv38vD4noTXimrPhWTNZz/DoorZelbKtaLgmX/WpIzaYDXA1sztYTfAd1LJoIfYflzM4tvy1Mnth2fOdE/Ic03H6+f1x7nnh2bOsJzeoYjZg2LNd1PJlnnU8u/4q5XcrJbdjW7R3tbwimvQt6Xhybvot6ThaUHD8/H4hmXOvKrj6eX0YTbAZj3C/Pz8+/v7XjO/c36B9wAAAKRJREFUeNoczmlbgVEYReGH19hsStIoKUMhKTQL59nr//+gjj6tfd2ftk3Dr7sfhdCSNAkvdgNN9zz0IlzzZLswcL8Hyyl3R9VqUNGIYiCtDpyYP/KqMc9z2vrmOGV+RaI8Bw2GOuNc5odYIcNaULjgM8Ip7N1mpRLdH+oRPEOWD6nMhpDawj6wktIxD9rCV1x9aRmz+IfZTkjie72Fy3fpT4ABAEkyKdWiQoaCAAAAAElFTkSuQmCC" alt=""></div><div class="contrimetrics_weight_item_right" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">M2 macrophage-derived exosomes induce angiogenesis and increase skin flap survival through hif1an/hif-1α/vegfa control</div></div><div class="contrimetrics_weight_item_two" style="word-break: normal !important; white-space:normal!important; overflow-wrap: break-word !important;hyphens:none !important;">Archives of Biochemistry and Biophysics, 2023</div></div></div></div></div></div></div><div class="contrimetrics_weight_bottom"><div class="inside_contrimetrics_weight_bottom"> <div class="contrimetrics_weight_bottom_inner">Powered by <a href="https://contrimetrics.com/login?journalId=1935235368180158504" target="_blank"><img hspace="5" src="data:image/png;base64,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" alt=""></a></div><div class="contrimetrics_weight_favorite">
<span class="contrimetrics_weight_alert"></span><div><input type="text" placeholder="EMAIL ADDRESS"> <button>
Favorite</button></div>
</div></div></div>`,
};

export const widgetPartsCss = {
  1: `.contrimetrics_weight_section {

	width: 100% !important;

	display: flex !important;

	justify-content: space-between !important;

}



.contrimetrics_weight_section * {

	margin: 0 !important;

	padding: 0 !important;

	text-align: left !important;

	line-height: 20px !important;

	font-size: inherit !important;

	font-family: "Times New Roman", sans-serif !important;

}



.contrimetrics_weight_section_left {

	width: 50% !important;

	background-color: white !important;

}



.contrimetrics_weight_section_right {

	width: 50% !important;

	background-color: white !important;

}



.contrimetrics_weight_inside__section_top_left,

.contrimetrics_weight_inside__section_top_right {

	width: 100% !important;

	color: white !important;

	padding: 14px 0 10px 0 !important;

	text-indent: 5% !important;

	border-radius: 0.625rem 0 0 !important;

	position: relative !important;

	font-weight: 700 !important;

}



.contrimetrics_weight_inside_section_bottom {

	width: 100% !important;

	background-color: white !important;

	display: flex !important;

	flex-direction: column !important;

	justify-content: center !important;

}



.contrimetrics_weight_item {

	width: 90% !important;

	display: flex !important;

	align-items: flex-start !important;

	padding: 0 0 0 1% !important;

	gap: 2px;

}



.contrimetrics_weight_item_checkbox {

	width: 9% !important;

	min-width: 9% !important;

	display: flex !important;

	justify-content: right !important;

}



.contrimetrics_weight_item_checkbox>input[type=checkbox] {

	opacity: unset !important;

	margin: 0 !important;

	z-index: 10 !important;

}



input:not([disabled]):focus:focus {

	outline: unset !important;

	will-change: unset !important;

}



.contrimetrics_weight_item_warp_right {

	width: 95% !important;

}



.contrimetrics_weight_item_one {

	display: flex !important;

	width: 100% !important;

	align-items: baseline !important;

	gap: 3px;

}



.contrimetrics_weight_item_left {

	width: 1rem !important;

	padding: 0 !important;

	font-weight: inherit !important;

	z-index: 10 !important;

}



.contrimetrics_weight_item_left>img {

	all: inherit !important;

	width: 100% !important;

}



.contrimetrics_weight_item_right {

	width: 94% !important;

	hyphens: auto !important;

	text-overflow: -o-ellipsis-lastline !important;

	overflow: hidden !important;

	text-overflow: ellipsis !important;

	display: -webkit-box !important;

	-webkit-line-clamp: 2 !important;

	-webkit-box-orient: vertical !important;

}



.contrimetrics_weight_item_two {

	width: 95% !important;

	padding: 0 0 3% 18px !important;

	word-break: break-all !important;

}



.contrimetrics_mark:hover:after {

	font-weight: 100 !important;

	display: unset !important;

	position: absolute !important;

	bottom: 2rem !important;

	left: -5rem !important;

	width: 23rem !important;

	content: attr(data-title) !important;

	padding: 17px 10px 17px 10px !important;

	border: 1px solid #d4d4d6 !important;

	border-radius: 5px !important;

	background-color: #e5e5e5 !important;

	hyphens: auto !important;

	text-align: left !important;

	text-indent: 0 !important;

	z-index: 100 !important;

}



.contrimetrics_mark {

	font-weight: 100 !important;

	display: inline-block !important;

	position: relative !important;

	top: 0 !important;

	margin-left: 10px !important;

	border-radius: 50% !important;

	color: black !important;

	text-align: center !important;

	text-indent: 0 !important;

}



.contrimetrics_mark:hover+.contrimetrics_pop {

	display: block !important;

}



.contrimetrics_weight_bottom {

	width: 100% !important;

	padding: 2px 0;

	border-top: 1px solid #d4d4d6 !important;

	color: #aaaaac !important;

	font-weight: 500 !important;

	background: white !important;

	font-family: "Times New Roman", sans-serif !important;

}



.inside_contrimetrics_weight_bottom {

	margin: 10px !important;

	display: flex !important;

	justify-content: space-between !important;

}



.contrimetrics_weight_bottom_inner {

	display: flex;

	color: #707070 !important;

	margin: 0;

	font-family: "Times New Roman", sans-serif !important;

}



.contrimetrics_weight_bottom_inner img{

	margin: 0 5px;

}



.contrimetrics_weight_bottom_inner a:hover {

	color: transparent !important;

	background-color: unset !important;

}



.contrimetrics_weight_alert {

	margin-right: 8px !important;

	display: flex !important;

	align-items: center !important;

}



.contrimetrics_weight_favorite {

	display: flex !important;

	animation: slidein 0.2s infinite alternate;

	opacity: 1;

	transition: opacity 0.3s ease;

	margin: 0;

}



@keyframes slidein {

	from {

		opacity: 0;

	}



	to {

		opacity: 1;

	}

}



.contrimetrics_weight_favorite div {

	display: flex !important;

	align-items: center !important;

}



.contrimetrics_weight_favorite input {

	border: 1px solid #efefef !important;

	border-radius: unset !important;

	box-shadow: unset !important;

	background: unset !important;

	padding: 0 !important;

	margin: 0 !important;

	line-height: 22px !important;

	height: inherit !important;

}



.contrimetrics_weight_favorite input::placeholder {

	font-size: 13px !important;

	font-family: "Times New Roman", sans-serif !important;

	font-style: normal !important;

	color: rgb(162, 177, 182) !important;

}



.contrimetrics_weight_favorite input:focus-visible {

	box-shadow: unset !important;

	outline: unset !important;

	outline-offset: unset !important;

}



.contrimetrics_weight_favorite a {

	line-height: 20px !important;

	border: 1px solid black !important;

	padding: 0px 2px !important;

	font-weight: normal !important;

	color: #000 !important;

	text-decoration: none !important;

	background-color: rgb(239, 239, 239) !important;

}



.contrimetrics_weight_favorite a.focus,

.contrimetrics_weight_favorite a:hover {

	outline: unset !important;

	color: #fff !important;

	background-color: rgb(0 148 170) !important;

	border-color: rgb(0 148 170) !important;

}

.contrimetrics_weight_inside__section_top_left,.contrimetrics_weight_inside__section_top_right{text-indent:4% !important}.contrimetrics_weight_section,.contrimetrics_weight_favorite{flex-direction:column !important}.inside_contrimetrics_weight_bottom{flex-direction:column !important;gap:10px !important}.contrimetrics_weight_section_left,.contrimetrics_weight_section_right{width:100% !important}

.contrimetrics_weight_inside__section_top_left, .contrimetrics_weight_inside__section_top_right { text-indent: 4% !important; }

.contrimetrics_weight_section, .contrimetrics_weight_favorite { flex-direction: column !important; }

.inside_contrimetrics_weight_bottom { flex-direction: column !important; gap: 10px !important; }

.contrimetrics_weight_section_left, .contrimetrics_weight_section_right { width: 100% !important; }`,
  2: `.contrimetrics_weight_section {

	width: 100%;

	display: flex;

	justify-content: space-between;

}



.contrimetrics_weight_section * {

	margin: 0;

	padding: 0;

	text-align: left;

	line-height: 20px;

	font-size: inherit;

	font-family: "Times New Roman", sans-serif;

}



.contrimetrics_weight_section_left {

	width: 50%;

	background-color: white;

}



.contrimetrics_weight_section_right {

	width: 50%;

	background-color: white;

}



.contrimetrics_weight_inside__section_top_left,

.contrimetrics_weight_inside__section_top_right {

	width: 100%;

	color: white;

	padding: 14px 0;

	text-indent: 5%;

	border-radius: 0.625rem 0 0;

	position: relative;

	font-weight: 700;

}



.contrimetrics_weight_inside_section_bottom {

	width: 100%;

	background-color: white;

	display: flex;

	flex-direction: column;

	justify-content: center;

}



.contrimetrics_weight_item {

	width: 90%;

	display: flex;

	align-items: flex-start;

	padding: 0 0 0 1%;

	gap: 2px;

}



.contrimetrics_weight_item_checkbox {

	width: 9%;

	min-width: 9%;

	display: flex;

	justify-content: right;

}



.contrimetrics_weight_item_checkbox>input[type=checkbox] {

	opacity: unset;

	margin: 0;

	z-index: 10;

}



input:not([disabled]):focus:focus {

	outline: unset;

	will-change: unset;

}



.contrimetrics_weight_item_warp_right {

	width: 95%;

}



.contrimetrics_weight_item_one {

	display: flex;

	width: 100%;

	align-items: baseline;

	gap: 3px;

}



.contrimetrics_weight_item_left {

	width: 1rem;

	padding: 0;

	font-weight: inherit;

	z-index: 10;

}



.contrimetrics_weight_item_left>img {

	all: inherit;

	width: 100%;

}



.contrimetrics_weight_item_right {

	width: 94%;

	hyphens: auto;

	text-overflow: -o-ellipsis-lastline;

	overflow: hidden;

	text-overflow: ellipsis;

	display: -webkit-box;

	-webkit-line-clamp: 2;

	-webkit-box-orient: vertical;

}



.contrimetrics_weight_item_two {

	width: 95%;

	padding: 0 0 3% 18px;

	word-break: break-all;

}



.contrimetrics_mark:hover:after {

	font-weight: 100;

	display: unset;

	position: absolute;

	bottom: 32px;

    left: -80px;

    width: 368px;

	content: attr(data-title);

	padding: 17px 10px;

	border: 1px solid #d4d4d6;

	border-radius: 5px;

	background-color: #e5e5e5;

	hyphens: auto;

	text-align: left;

	text-indent: 0;

	z-index: 100;

}



.contrimetrics_mark {

	font-weight: 100;

	display: inline-block;

	position: relative;

	top: 0;

	margin-left: 10px;

	border-radius: 50%;

	color: black;

	text-align: center;

	text-indent: 0;

}



.contrimetrics_mark:hover+.contrimetrics_pop {

	display: block;

}



.contrimetrics_weight_bottom {

	width: 100%;

	padding: 2px 0;

	border-top: 1px solid #d4d4d6;

	color: #aaaaac;

	font-weight: 500;

	background: white;

	font-family: "Times New Roman", sans-serif;

}



.inside_contrimetrics_weight_bottom {

	margin: 10px;

	display: flex;

	justify-content: space-between;

}



.contrimetrics_weight_bottom_inner {

	display: flex;

	color: #707070;

	margin: 0;

	font-family: "Times New Roman", sans-serif;

}



.contrimetrics_weight_bottom_inner img {

	margin: 0 5px;

}



.contrimetrics_weight_bottom_inner a:hover {

	color: transparent;

	background-color: unset;

}



.contrimetrics_weight_alert {

	margin-right: 8px;

	display: flex;

	align-items: center;

}



.contrimetrics_weight_favorite {

	display: flex;

	animation: slidein 0.2s infinite alternate;

	opacity: 1;

	transition: opacity 0.3s ease;

	margin: 0;

}



@keyframes slidein {

	from {

		opacity: 0;

	}



	to {

		opacity: 1;

	}

}



.contrimetrics_weight_favorite div {

	display: flex;

	align-items: center;

}



.contrimetrics_weight_favorite input {

	border: 1px solid #efefef;

	border-radius: unset;

	box-shadow: unset;

	background: unset;

	padding: 0;

	margin: 0;

	line-height: 22px;

	height: inherit;

}



.contrimetrics_weight_favorite input::placeholder {

	font-size: 13px;

	font-family: "Times New Roman", sans-serif;

	font-style: normal;

	color: rgb(162, 177, 182);

}



.contrimetrics_weight_favorite input:focus-visible {

	box-shadow: unset;

	outline: unset;

	outline-offset: unset;

}



.contrimetrics_weight_favorite a {

	line-height: 20px;

	border: 1px solid black;

	padding: 0px 2px;

	font-weight: normal;

	color: #000;

	text-decoration: none;

	background-color: rgb(239, 239, 239);

}



.contrimetrics_weight_favorite a.focus,

.contrimetrics_weight_favorite a:hover {

	outline: unset;

	color: #fff;

	background-color: rgb(0 148 170);

	border-color: rgb(0 148 170);

}`,
  3: `.contrimetrics_weight_section {

	margin-top: 40px;

	width: 100% !important;

	display: flex !important;

	justify-content: space-between !important;

}



.contrimetric_left_list a {

	color: #666;

	font-weight: 700;

}



.contrimetric_left_list.active a {

	color: #0178d6;

	font-weight: bold;

}



.contrimetrics_weight_section * {

	margin: 0 !important;

	padding: 0 !important;

	text-align: left !important;

	line-height: 20px !important;

	font-size: inherit !important;

	font-family: "Times New Roman", sans-serif !important;

}



.contrimetrics_weight_section_left {

	width: 50% !important;

	background-color: white !important;

}



.contrimetrics_weight_section_right {

	width: 50% !important;

	background-color: white !important;

}



.contrimetrics_weight_inside__section_top_left,

.contrimetrics_weight_inside__section_top_right {

	width: 100% !important;

	color: white !important;

	padding: 14px 0 10px 0 !important;

	text-indent: 5% !important;

	border-radius: 0.625rem 0 0 !important;

	position: relative !important;

	font-weight: 700 !important;

}



.contrimetrics_weight_inside_section_bottom {

	width: 100% !important;

	background-color: white !important;

	display: flex !important;

	flex-direction: column !important;

	justify-content: center !important;

}



.contrimetrics_weight_item {

	width: 90% !important;

	display: flex !important;

	align-items: flex-start !important;

	padding: 0 0 0 1% !important;

	gap: 2px;

}



.contrimetrics_weight_item_checkbox {

	width: 9% !important;

	min-width: 9% !important;

	display: flex !important;

	justify-content: right !important;

}



.contrimetrics_weight_item_checkbox>input[type=checkbox] {

	opacity: unset !important;

	margin: 0 !important;

	z-index: 10 !important;

}



input:not([disabled]):focus:focus {

	outline: unset !important;

	will-change: unset !important;

}



.contrimetrics_weight_item_warp_right {

	width: 95% !important;

}



.contrimetrics_weight_item_one {

	display: flex !important;

	width: 100% !important;

	align-items: baseline !important;

	gap: 3px;

}



.contrimetrics_weight_item_left {

	width: 1rem !important;

	padding: 0 !important;

	font-weight: inherit !important;

	z-index: 10 !important;

}



.contrimetrics_weight_item_left>img {

	all: inherit !important;

	width: 100% !important;

}



.contrimetrics_weight_item_right {

	width: 94% !important;

	hyphens: auto !important;

	text-overflow: -o-ellipsis-lastline !important;

	overflow: hidden !important;

	text-overflow: ellipsis !important;

	display: -webkit-box !important;

	-webkit-line-clamp: 2 !important;

	-webkit-box-orient: vertical !important;

}



.contrimetrics_weight_item_two {

	width: 95% !important;

	padding: 0 0 3% 18px !important;

	word-break: break-all !important;

}



.contrimetrics_mark:hover:after {

	font-weight: 100 !important;

	display: unset !important;

	position: absolute !important;

	bottom: 2rem !important;

	left: -5rem !important;

	width: 23rem !important;

	content: attr(data-title) !important;

	padding: 17px 10px 17px 10px !important;

	border: 1px solid #d4d4d6 !important;

	border-radius: 5px !important;

	background-color: #e5e5e5 !important;

	hyphens: auto !important;

	text-align: left !important;

	text-indent: 0 !important;

	z-index: 100 !important;

}



.contrimetrics_mark {

	font-weight: 100 !important;

	display: inline-block !important;

	position: relative !important;

	top: 0 !important;

	margin-left: 10px !important;

	border-radius: 50% !important;

	color: black !important;

	text-align: center !important;

	text-indent: 0 !important;

}



.contrimetrics_mark:hover+.contrimetrics_pop {

	display: block !important;

}



.contrimetrics_weight_bottom {

	width: 100% !important;

	padding: 2px 0;

	border-top: 1px solid #d4d4d6 !important;

	color: #aaaaac !important;

	font-weight: 500 !important;

	background: white !important;

	font-family: "Times New Roman", sans-serif !important;

}



.inside_contrimetrics_weight_bottom {

	margin: 10px !important;

	display: flex !important;

	justify-content: space-between !important;

}



.contrimetrics_weight_bottom_inner {

	display: flex;

	color: #707070 !important;

	margin: 0;

	font-family: "Times New Roman", sans-serif !important;

}



.contrimetrics_weight_bottom_inner img {

	margin: 0 5px;

}



.contrimetrics_weight_bottom_inner a:hover {

	color: transparent !important;

	background-color: unset !important;

}



.contrimetrics_weight_alert {

	margin-right: 8px !important;

	display: flex !important;

	align-items: center !important;

}



.contrimetrics_weight_favorite {

	display: flex !important;

	animation: slidein 0.2s infinite alternate;

	opacity: 1;

	transition: opacity 0.3s ease;

	margin: 0;

}



@keyframes slidein {

	from {

		opacity: 0;

	}



	to {

		opacity: 1;

	}

}



.contrimetrics_weight_favorite div {

	display: flex !important;

	align-items: center !important;

}



.contrimetrics_weight_favorite input {

	border: 1px solid #efefef !important;

	border-radius: unset !important;

	box-shadow: unset !important;

	background: unset !important;

	padding: 0 !important;

	margin: 0 !important;

	line-height: 22px !important;

	height: inherit !important;

}



.contrimetrics_weight_favorite input::placeholder {

	font-size: 13px !important;

	font-family: "Times New Roman", sans-serif !important;

	font-style: normal !important;

	color: rgb(162, 177, 182) !important;

}



.contrimetrics_weight_favorite input:focus-visible {

	box-shadow: unset !important;

	outline: unset !important;

	outline-offset: unset !important;

}



.contrimetrics_weight_favorite a {

	line-height: 20px !important;

	border: 1px solid black !important;

	padding: 0px 2px !important;

	font-weight: normal !important;

	color: #000 !important;

	text-decoration: none !important;

	background-color: rgb(239, 239, 239) !important;

}



.contrimetrics_weight_favorite a.focus,

.contrimetrics_weight_favorite a:hover {

	outline: unset !important;

	color: #fff !important;

	background-color: rgb(0 148 170) !important;

	border-color: rgb(0 148 170) !important;

}`,
  4: `.contrimetrics_weight_section {

	margin-top: 40px;

	width: 100% !important;

	display: flex !important;

	justify-content: space-between !important;

}



.contrimetrics_weight_section * {

	margin: 0 !important;

	padding: 0 !important;

	text-align: left !important;

	line-height: 20px !important;

	font-size: inherit !important;

	font-family: "Times New Roman", sans-serif !important;

}



.contrimetrics_weight_section_left {

	width: 50% !important;

	background-color: white !important;

}



.contrimetrics_weight_section_right {

	width: 50% !important;

	background-color: white !important;

}



.contrimetrics_weight_inside__section_top_left,

.contrimetrics_weight_inside__section_top_right {

	width: 100% !important;

	color: white !important;

	padding: 14px 0 10px 0 !important;

	text-indent: 5% !important;

	border-radius: 0.625rem 0 0 !important;

	position: relative !important;

	font-weight: 700 !important;

}



.contrimetrics_weight_inside_section_bottom {

	width: 100% !important;

	background-color: white !important;

	display: flex !important;

	flex-direction: column !important;

	justify-content: center !important;

}



.contrimetrics_weight_item {

	width: 90% !important;

	display: flex !important;

	align-items: flex-start !important;

	padding: 0 0 0 1% !important;

	gap: 2px;

}



.contrimetrics_weight_item_checkbox {

	width: 9% !important;

	min-width: 9% !important;

	display: flex !important;

	justify-content: right !important;

}



.contrimetrics_weight_item_checkbox>input[type=checkbox] {

	opacity: unset !important;

	margin: 0 !important;

	z-index: 10000 !important;

}



input:not([disabled]):focus:focus {

	outline: unset !important;

	will-change: unset !important;

}



.contrimetrics_weight_item_warp_right {

	width: 95% !important;

}



.contrimetrics_weight_item_one {

	display: flex !important;

	width: 100% !important;

	align-items: baseline !important;

	gap: 3px;

}



.contrimetrics_weight_item_left {

	width: 1rem !important;

	padding: 0 !important;

	font-weight: inherit !important;

	z-index: 100000 !important;

}



.contrimetrics_weight_item_left>img {

	all: inherit !important;

	width: 100% !important;

}



.contrimetrics_weight_item_right {

	width: 94% !important;

	hyphens: auto !important;

	text-overflow: -o-ellipsis-lastline !important;

	overflow: hidden !important;

	text-overflow: ellipsis !important;

	display: -webkit-box !important;

	-webkit-line-clamp: 2 !important;

	-webkit-box-orient: vertical !important;

}



.contrimetrics_weight_item_two {

	width: 95% !important;

	padding: 0 0 3% 18px !important;

	word-break: break-all !important;

}



.contrimetrics_mark:hover:after {

	font-weight: 100 !important;

	display: unset !important;

	position: absolute !important;

	bottom: 2rem !important;

	left: -5rem !important;

	width: 22rem !important;

	content: attr(data-title) !important;

	padding: 17px 10px 17px 10px !important;

	border: 1px solid #d4d4d6 !important;

	border-radius: 5px !important;

	background-color: #e5e5e5 !important;

	hyphens: auto !important;

	text-align: justify !important;

	text-indent: 0 !important;

	z-index: 10000 !important;

}



.contrimetrics_mark {

	font-weight: 100 !important;

	display: inline-block !important;

	position: relative !important;

	top: 0 !important;

	margin-left: 10px !important;

	border-radius: 50% !important;

	color: black !important;

	text-align: center !important;

	text-indent: 0 !important;

}



.contrimetrics_mark:hover+.contrimetrics_pop {

	display: block !important;

}



.contrimetrics_weight_bottom {

	width: 100% !important;

	padding: 2px 0;

	border-top: 1px solid #d4d4d6 !important;

	color: #aaaaac !important;

	font-weight: 500 !important;

	background: white !important;

	font-family: "Times New Roman", sans-serif !important;

}



.inside_contrimetrics_weight_bottom {

	margin: 0.75rem !important;

	display: flex !important;

	justify-content: space-between !important;

}



.contrimetrics_weight_bottom_inner {

	color: #707070 !important;

}



.contrimetrics_weight_bottom_inner a:hover {

	color: transparent !important;

	background-color: unset !important;

}



.contrimetrics_weight_alert {

	margin-right: 0.625rem !important;

	display: flex !important;

	align-items: center !important;

}



.contrimetrics_weight_favorite {

	display: flex !important;

	animation: slidein 0.2s infinite alternate;

	opacity: 1;

	transition: opacity 0.3s ease;

}



@keyframes slidein {

	from {

		opacity: 0;

	}



	to {

		opacity: 1;

	}

}



.contrimetrics_weight_favorite div {

	display: flex !important;

	align-items: center !important;

}



.contrimetrics_weight_favorite input {

	border: 1px solid #efefef !important;

	border-radius: unset !important;

	box-shadow: unset !important;

	background: unset !important;

	padding: 0 !important;

	margin: 0 !important;

	line-height: 22px !important;

	height: inherit !important;

}



.contrimetrics_weight_favorite input::placeholder {

	font-size: 13px !important;

	font-family: "Times New Roman", sans-serif !important;

}



.contrimetrics_weight_favorite input:focus-visible {

	box-shadow: unset !important;

	outline: unset !important;

	outline-offset: unset !important;

}



.contrimetrics_weight_favorite a {

	line-height: 20px !important;

	border: 1px solid black !important;

	padding: 0px 2px !important;

	font-weight: normal !important;

	color: #000 !important;

	text-decoration: none !important;

	background-color: rgb(239, 239, 239) !important;

}



.contrimetrics_weight_favorite a.focus,

.contrimetrics_weight_favorite a:hover {

	outline: unset !important;

	color: #fff !important;

	background-color: rgb(0 148 170) !important;

	border-color: rgb(0 148 170) !important;

}



@media (max-width: 1200px) {

	.contrimetrics_weight_inside__section_top_left,

	.contrimetrics_weight_inside__section_top_right {

		text-indent: 4% !important;

	}



	@media (max-width: 767px) {



		.contrimetrics_weight_section {

			flex-direction: column !important;

		}



		.contrimetrics_weight_section_left,

		.contrimetrics_weight_section_right {

			width: 100% !important;

		}

	}

}`,
};
